<p-toast></p-toast>

<p-sidebar
  [(visible)]="open"
  position="right"
  (onHide)="onClose()"
  [modal]="false"
  [style]="{ width: '36em' }"
  [showCloseIcon]="false"
>
  <ng-template pTemplate>
    <div class="surface-card p-4 shadow-2 border-round">
      <div class="font-medium text-2xl text-700 mb-3">{{ settings.title }}</div>
      <div class="text-500 mb-5">
        Revisar la información del producto, antes de considerar su agregación a
        la orden de compra.
      </div>
      <form [formGroup]="fg">
        <ul class="list-none p-0 m-0">
          <li
            *ngFor="let item of itemStock"
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-2 md:w-5 font-medium">
              {{ item.label }}
            </div>
            <div
              class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
            >
              {{ item.value }}
            </div>
          </li>
          <li
            *ngIf="!itemReception && !itemInvoice"
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-2 md:w-4 font-medium">Cantidad</div>
            <div class="w-auto md:w-8 md:flex-order-0 flex-order-1">
              <p-inputNumber
                formControlName="quantity"
                mode="decimal"
                class="size-1"
                [showButtons]="true"
                inputId="minmax-buttons"
                (onInput)="onInputQuantity($event)"
              >
              </p-inputNumber>
              <div
                *ngIf="
                  fg.get('quantity').invalid &&
                  (fg.get('quantity').dirty || fg.get('quantity').touched)
                "
                class="p-invalid"
              >
                <div *ngIf="fg.get('quantity').errors?.required">
                  <small class="p-error">No puede quedar vacio.</small>
                </div>
                <div *ngIf="fg.get('quantity').errors?.min">
                  <small class="p-error"
                    >Debe tener un valor minimo de 1.</small
                  >
                </div>
                <div *ngIf="fg.get('quantity').errors?.max">
                  <small class="p-error"
                    >Debe tener un valor maximo de {{ quantityMax }}.</small
                  >
                </div>
              </div>
            </div>
          </li>
          <li
            *ngIf="itemInvoice"
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-2 md:w-4 font-medium">Cantidad</div>
            <div class="w-auto md:w-8 md:flex-order-0 flex-order-1">
              <p-inputNumber
                formControlName="quantity_cart"
                mode="decimal"
                class="size-1"
                [showButtons]="true"
                inputId="minmax-buttons"
              >
              </p-inputNumber>
              <div
                *ngIf="
                  fg.get('quantity_cart').invalid &&
                  (fg.get('quantity_cart').dirty ||
                    fg.get('quantity_cart').touched)
                "
                class="p-invalid"
              >
                <div *ngIf="fg.get('quantity_cart').errors?.required">
                  <small class="p-error">No puede quedar vacio.</small>
                </div>
                <div *ngIf="fg.get('quantity_cart').errors?.min">
                  <small class="p-error"
                    >Debe tener un valor minimo de 1.</small
                  >
                </div>
                <div *ngIf="fg.get('quantity_cart').errors?.max">
                  <small class="p-error"
                    >Debe tener un valor maximo de {{ quantityMax }}.</small
                  >
                </div>
              </div>
            </div>
          </li>
          <li
            *ngIf="itemReception"
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-2 md:w-4 font-medium">Cantidad</div>
            <div class="w-auto md:w-8 md:flex-order-0 flex-order-1">
              <p-inputNumber
                formControlName="quantity_cart"
                mode="decimal"
                class="size-1"
                [showButtons]="true"
                inputId="minmax-buttons"
              >
              </p-inputNumber>
              <div
                *ngIf="
                  fg.get('quantity_cart').invalid &&
                  (fg.get('quantity_cart').dirty ||
                    fg.get('quantity_cart').touched)
                "
                class="p-invalid"
              >
                <div *ngIf="fg.get('quantity_cart').errors?.required">
                  <small class="p-error">No puede quedar vacio.</small>
                </div>
                <div *ngIf="fg.get('quantity_cart').errors?.min">
                  <small class="p-error"
                    >Debe tener un valor minimo de 1.</small
                  >
                </div>
                <div *ngIf="fg.get('quantity_cart').errors?.max">
                  <small class="p-error"
                    >Debe tener un valor maximo de {{ quantityMax }}.</small
                  >
                </div>
              </div>
            </div>
          </li>
          <li
            *ngIf="!itemReception && !itemInvoice"
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-2 md:w-4 font-medium">Precio unitario</div>
            <div class="w-auto md:w-8 md:flex-order-0 flex-order-1">
              <p-inputNumber
                formControlName="unitPrice"
                mode="decimal"
                [minFractionDigits]="2"
                class="size-1"
                [showButtons]="true"
                inputId="minmax-buttons"
                mode="currency"
                currency="PEN"
                (onInput)="onInputUnitPrice($event)"
              >
              </p-inputNumber>
              <div
                *ngIf="
                  fg.get('unitPrice').invalid &&
                  (fg.get('unitPrice').dirty || fg.get('unitPrice').touched)
                "
                class="p-invalid"
              >
                <div *ngIf="fg.get('unitPrice').errors?.min">
                  <small class="p-error"
                    >Debe tener un valor minimo de 1.</small
                  >
                </div>
                <div *ngIf="fg.get('unitPrice').errors?.required">
                  <small class="p-error">No puede quedar vacio.</small>
                </div>
              </div>
            </div>
          </li>

          <li
            *ngIf="itemReception"
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-2 md:w-4 font-medium">Lote</div>
            <div class="w-auto md:w-8 md:flex-order-0 flex-order-1">
              <input
                type="text"
                pInputText
                placeholder="Ingrese el código de lote"
                formControlName="lot"
                class="size-1"
              />
              <div
                *ngIf="
                  fg.get('lot').invalid &&
                  (fg.get('lot').dirty || fg.get('lot').touched)
                "
                class="p-invalid"
              >
                <small class="p-error">No puede quedar vacio.</small>
              </div>
            </div>
          </li>

          <li
            *ngIf="itemReception"
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-2 md:w-4 font-medium">
              Fecha de vencimiento
            </div>
            <div class="w-auto md:w-8 md:flex-order-0 flex-order-1">
              <input
                type="date"
                pInputText
                placeholder="Ingrese fecha de vencimiento"
                formControlName="expDate"
                class="size-1"
              />
              <div
                *ngIf="
                  fg.get('expDate').invalid &&
                  (fg.get('expDate').dirty || fg.get('expDate').touched)
                "
                class="p-invalid"
              >
                <div *ngIf="fg.get('expDate').errors?.required">
                  <small class="p-error">No puede quedar vacio.</small>
                </div>
              </div>
            </div>
          </li>

          <li
            *ngIf="!itemReception && !itemInvoice"
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-2 md:w-4 font-medium">Descuento</div>
            <div class="w-auto md:w-8 md:flex-order-0 flex-order-1">
              <p-inputNumber
                [ngModel]="discount"
                formControlName="discount"
                mode="decimal"
                [minFractionDigits]="2"
                class="size-1"
                [showButtons]="true"
                inputId="minmax-buttons"
                mode="currency"
                currency="PEN"
                (onInput)="onInputDiscount($event)"
                [max]="unitPrice"
              >
              </p-inputNumber>
              <div
                *ngIf="
                  fg.get('discount').invalid &&
                  (fg.get('discount').dirty || fg.get('discount').touched)
                "
                class="p-invalid"
              >
                <div *ngIf="fg.get('discount').errors?.min">
                  <small class="p-error"
                    >Debe tener un valor minimo de 1.</small
                  >
                </div>
                <div *ngIf="fg.get('discount').errors?.max">
                  <small class="p-error"
                    >Debe tener un valor menor al Precio Unitario.</small
                  >
                </div>
                <div *ngIf="fg.get('discount').errors?.required">
                  <small class="p-error">No puede quedar vacio.</small>
                </div>
              </div>
            </div>
          </li>
          <div *ngIf="!itemReception && !itemInvoice">
            <li
              class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
            >
              <div class="text-500 w-2 md:w-5 font-medium">Total Bruto</div>
              <div
                class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
              >
                S/ {{ grossTotal }}
              </div>
            </li>

            <li
              class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
            >
              <div class="text-500 w-2 md:w-5 font-medium">Impuesto</div>
              <div
                class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
              >
                {{ tax * 100 }}%
              </div>
            </li>
            <li
              class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
            >
              <div class="text-500 w-2 md:w-5 font-medium">
                Suma de Impuesto
              </div>
              <div
                class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
              >
                S/ {{ totalTax }}
              </div>
            </li>
            <li
              class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
            >
              <div class="text-500 w-2 md:w-5 font-medium">Total Neto</div>
              <div
                class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
              >
                S/ {{ netTotal }}
              </div>
            </li>
          </div>

          <li
            class="flex align-items-center justify-content-end flex-wrap py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <button
              pButton
              pRipple
              (click)="onClose()"
              icon="pi pi-times"
              class="p-button-text"
              pTooltip="Cancelar"
              tooltipPosition="left"
              label="No"
            ></button>
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              class="p-button-text"
              icon="pi pi-check"
              [disabled]="fg.invalid"
              label="Si"
              [pTooltip]="settings.tooltip"
              tooltipPosition="left"
            ></button>
          </li>
        </ul>
      </form>
    </div>
  </ng-template>
</p-sidebar>
